import React from 'react';
import { MdClose, MdEmail, MdDomain, MdCalendarToday, MdVerifiedUser, MdPerson, MdSend } from 'react-icons/md';
import './CustomerOffcanvas.css';

const SingleScanOffcanvas = ({ show, onHide, scanData }) => {
  if (!show || !scanData) return null;

  return (
    <div className="customer-offcanvas-backdrop" onClick={onHide}>
      <div className="customer-offcanvas" onClick={(e) => e.stopPropagation()}>
        <div className="customer-offcanvas-header">
          <div className="header-content">
            <div className="customer-avatar">
              <MdPerson size={24} />
            </div>
            <div>
              <h4 className="customer-name">
                {scanData.firstName} {scanData.lastName}
              </h4>
              <p className="customer-email">{scanData.email}</p>
            </div>
          </div>
          <button className="close-btn" onClick={onHide}>
            <MdClose size={24} />
          </button>
        </div>

        <div className="customer-offcanvas-body">
          <div className="info-section">
            <h5 className="section-title">Basic Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdEmail size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Email Address</span>
                <span className="info-value">{scanData.email}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdDomain size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Domain</span>
                <span className="info-value">{scanData.domain}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdDomain size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Scan Domain</span>
                <span className="info-value">{scanData.scanDomain}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Scan Created</span>
                <span className="info-value">{new Date(scanData.scanCreatedAt).toLocaleDateString()}</span>
              </div>
            </div>
          </div>

          <div className="status-section">
            <h5 className="section-title">Status Information</h5>
            
            <div className="status-grid">
              <div className="status-card">
                <div className={`status-icon ${scanData.verified ? 'verified' : 'pending'}`}>
                  <MdVerifiedUser size={20} />
                </div>
                <div className="status-content">
                  <span className="status-label">Verification Status</span>
                  <span className={`status-badge ${scanData.verified ? 'verified' : 'pending'}`}>
                    {scanData.verified ? 'Verified' : 'Not Verified'}
                  </span>
                </div>
              </div>

              <div className="status-card">
                <div className={`status-icon ${scanData.reportSend ? 'verified' : 'pending'}`}>
                  <MdSend size={20} />
                </div>
                <div className="status-content">
                  <span className="status-label">Report Status</span>
                  <span className={`status-badge ${scanData.reportSend ? 'verified' : 'pending'}`}>
                    {scanData.reportSend ? 'Sent' : 'Not Sent'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleScanOffcanvas;